import './App.css';
import CustomPkbwlTable from "./components/CustomPkbwlTable/CustomPkbwlTable";
import {useState} from "react";
import {Box, createTheme, ThemeProvider} from "@mui/material";
import {plPL} from "@mui/x-data-grid";
import {plPL as coreplPL} from "@mui/material/locale";
import FetchLoaderForOneResourceUrl from "./components/FetchLoaderForOneResourceUrl/FetchLoaderForOneResourceUrl";
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {isMobile} from 'react-device-detect';

export const queryClient = new QueryClient()

function App() {

    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);

    const theme = createTheme(
        {
            palette: {
                type: 'dark'
            },
            typography: {
                fontSize: 12
            },
        },
        plPL,
        coreplPL,
    );

    const containerBoxStyles = {
        margin: '5rem 0',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: isMobile ? '28rem' : 0
    }
    const boxWidth = isMobile ?
        {
            width: 1300
        } : {
            maxWidth: '100vw!important',
        }

    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
                <Box sx={
                    containerBoxStyles
                }>
                    <Box
                        sx={boxWidth}
                    >
                        <FetchLoaderForOneResourceUrl resource={'/api/pkbwl_reports/v1/reports'}>
                            <CustomPkbwlTable rows={rows} loading={loading}/>
                        </FetchLoaderForOneResourceUrl>
                    </Box>
                </Box>
            </ThemeProvider>
        </QueryClientProvider>
    );
}

export default App;
